import { DisciplinePage } from '../../../shared/components/DisciplinePage';
import { PlaceholderPanel } from '../../../shared/components/PlaceholderPanel';
import { useI18n } from '../../../../i18n';

export function CompliancePage() {
  const { t } = useI18n();
  return (
    <DisciplinePage
      accentColor="#0E243E"
      disciplineKey="compliance"
      disciplineTitle={t.sidebar.pageTitle.compliance}
      tabs={[
        {
          key: 'normative',
          label: t.compliance.tabs.normative,
          component: <PlaceholderPanel title={t.compliance.tabs.normative} />,
        },
        {
          key: 'internal-audit',
          label: t.compliance.tabs.internalAudit,
          component: <PlaceholderPanel title={t.compliance.tabs.internalAudit} />,
        },
        {
          key: 'non-conformities',
          label: t.compliance.tabs.nonConformities,
          component: <PlaceholderPanel title={t.compliance.tabs.nonConformities} />,
        },
      ]}
    />
  );
}
